/**
 * Simple HTML sanitization utility to remove style tags
 */

/**
 * Removes all <style> tags from HTML content to prevent global style application
 * @param htmlContent - The HTML content to sanitize
 * @returns HTML content with style tags removed
 */
export function removeStyleTags(htmlContent: string): string {
    if (!htmlContent) {
        return htmlContent;
    }

    try {
        // Use a regex to remove all <style> tags and their content
        return htmlContent.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');
    } catch (error) {
        console.warn('Failed to sanitize HTML content:', error);
        return htmlContent;
    }
}
